'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

export default function DetailHeaderActions({ href }: { href: string }) {
  const router = useRouter();
  return (
    <div className="flex flex-row justify-start items-center my-md md:mb-4xl">
      <button onClick={router.back}>
        <div className="flex flex-row items-center px-0 lg:px-xl py-lg gap-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M15 8.25H5.8725L10.065 4.0575L9 3L3 9L9 15L10.0575 13.9425L5.8725 9.75H15V8.25Z"
              fill="black"
            />
          </svg>
          zurück
        </div>
      </button>

      {/* tbc: Share link */}
    </div>
  );
}
